/**
*
*   Stockist form
*       - A Stockist Signup / Inquiry Form
*
**/
'use client';

import Config from '@/config';
import Button from '@/components/button';
import Storefront from '@/libraries/shopify/class';
import PageLoader from '@/libraries/pageloader';
import * as NProgress from 'nprogress';
import { useState, useEffect, useContext } from 'react';
import { useTranslations } from 'next-intl';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { getProviders, signIn } from 'next-auth/react'
import { getServerSession } from 'next-auth/next'
import { getCsrfToken } from 'next-auth/react'
import { useRouter, useSearchParams } from 'next/navigation'


//Build the Element
export default function LoginForm(){

    const { control, register, setError, formState: { errors, isSubmitting, isSubmitSuccessful }, handleSubmit } = useForm();
    const [ csrfToken , setCsrfToken ] = useState(null);
    const [ status , setStatus ] = useState(false);
    const [ loading , setLoading ] = useState(false);
    const [ pageLoader , setPageLoader ] = useState(false);
    const t = useTranslations();
    const router = useRouter();
    const searchParams = useSearchParams();

    //Form Settings
    const Form = {

        //Settings
        email: {
            validate: email => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email) || t('Forms.Errors.email.invalid')
        },

        //Error
        error: ({ message }) =>(<p className="error">{ message }</p> ),

        //A Thrown Error Message
        thrown: ( message ) => setError('root.serverError',{
            type: 500,
            message: t('errors.unknown') + ' ' + message
        }),

        //On Submit
        submit: data => {
            setLoading(true);
            signIn('credentials',{
                ...data,
                ...( destination => {
                    if( destination ) return {
                        callbackUrl: destination
                    }
                })( searchParams.get('callbackUrl') )
            }).then( ({ ok, error })=>{

                setLoading(false);

                //Redirect on Success
                if( ok ){
                    PageLoader.start();
                    router.push('/account');
                }

                //Error
                if( !ok && error )
                    setError(
                        'root.serverError',
                        ((e) => {
                            try {

                                //Get the JSON and format
                                error   = JSON.parse(error);
                                e       = {
                                    type:       ( error.status || e.type ),
                                    message:    error.errors.map( (e,i) => (<p key={i}>{ 
                                        ( e?.code == 'UNIDENTIFIED_CUSTOMER' ? t('Pages.Login.error') : e.message )
                                    }</p>) )
                                }

                            } catch( err ){
                                console.log(err);
                            }

                            return e;
                        })({
                            type:       500,
                            message:    ( t('Forms.Errors.unknown') ).replace(':','')
                        })
                    )
            });
        }
    };

    //Get the CSRF Token
    useEffect(() => {
        getCsrfToken().then( (token) => {
            setCsrfToken(token || null)
        });
    }, []);

    return (
        <form id="login-form" onSubmit={ handleSubmit(Form.submit) }>

            {/* Submission Response Error */}
            { errors.root?.serverError?.type > 200 && (
                <div className="failed">{
                    errors.root.serverError.message
                }</div>
            ) }

            {/* Row1 */}
            <div className="row">
                <div>
                    <label htmlFor="email">{ t('Forms.Labels.email') }</label>
                    <input name="email" placeholder={ t('Forms.Labels.email') + '*' } {...register('email', { required: t('Forms.Errors.required',{ type: t('Forms.Labels.email') }), validate: Form.email.validate })} />
                    <ErrorMessage errors={errors} name="email" render={ Form.error } />
                </div>
            </div>

            {/* Row2 */}
            <div className="row">
                <div>
                    <label htmlFor="password">{ t('Forms.Labels.password') }</label>
                    <input name="password" type="password" placeholder={ t('Forms.Labels.password') + '*' } {...register('password', { required:  t('Forms.Errors.required',{ type: t('Forms.Labels.password') }) })} />
                    <ErrorMessage errors={errors} name="password" render={ Form.error } />
                </div>
            </div>

            {/* Submit */}
            <div className="row submit">
                <div>
                    <input name="csrfToken" type="hidden" defaultValue={csrfToken} />
                    <Button disabled={ isSubmitting || loading } button type="submit">{ t('Navigation.sign-in') }</Button>
                </div>
            </div>

        </form>
    )

}